module.exports = __webpack_public_path__ + "static/img/textBookCenter.48ac88ee.png";